import client from '@libs/HttpClient';
import moment from 'moment';

class PublicReportService {
  //Attendance Master
  static listSignInOut(request) {
    const searchText = request.search;
    const startDate = request.start_date != '' ? moment(request.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
    const endDtae = request.end_date != '' ? moment(request.end_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
    return client.get(
      `/report/public/sign-in-out?search=${searchText}&start_date=${startDate}&end_date=${endDtae}`,
      request
    );
  }

  static listSignInOutInactiveUser(request) {
    const searchText = request.search;
    const startDate = request.start_date != '' ? moment(request.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
    const endDtae = request.end_date != '' ? moment(request.end_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
    return client.get(
      `/report/public/sign-in-out-inactive-user?search=${searchText}&start_date=${startDate}&end_date=${endDtae}`,
      request
    );
  }


}
export { PublicReportService };
